import React, { useState } from 'react';
import './style.scss';
import clsx from 'clsx';

const OTPField = (props) => {
  const keyPressCB = (e) => {
    let key = e.keyCode || e.charCode;
    const dataAttr = e.target.getAttribute('dataorder');
    if (key === 8 || key === 46) {
      const prevElemt = document.querySelector(`[dataorder="${+dataAttr - 1}"]`);
      if (prevElemt) {
        setTimeout(() => {
          prevElemt.focus();
        }, 50);
      }
    } else {
      const keyCode = e.key;
      const regex = new RegExp('^[0-9]+$');
      if (!regex.test(keyCode)) {
        e.preventDefault();
        return false;
      }
      if (e.key === '') {
        const prevElemt = document.querySelector(`[dataorder="${+dataAttr - 1}"]`);
        if (prevElemt) {
          setTimeout(() => {
            prevElemt.focus();
          }, 50);
        }
      } else {
        const nextElemt = document.querySelector(`[dataorder="${+dataAttr + 1}"]`);
        if (nextElemt) {
          setTimeout(() => {
            nextElemt.focus();
          }, 50);
        }
      }
    }
  };

  const handleChange = (e) => {
    if (props.error) {
      props.setError((prev) => {
        prev[1].status = false;
        prev[1].msg = '';
        return prev;
      });
    }
    const val = e.target.value;
    // Aplha numeric regex
    if (!/^[0-9]*$/.test(val)) {
      return;
    }
    const dataAttr = e.target.getAttribute('dataorder');
    props.setValue((prev) => {
      let res = [...prev];
      res[dataAttr] = val;
      let temp = [...props.value];
      temp[dataAttr] = val;
      props.setOtpValue(temp.join(''));
      return res;
    });
  };

  const handleFocus = (e) => {
    if (props.error) {
      props.setError((prev) => {
        prev[1].status = false;
        prev[1].msg = '';
        return prev;
      });
    }
    e.target.select();
  };

  return (
    <div className="form-otp-element">
      <div className="otp-title">{props?.field?.model?.title}</div>
      <div className={clsx('otp-fields', props.error && 'otp-fields-error')}>
        <input
          onKeyDown={keyPressCB}
          maxLength={1}
          onFocus={handleFocus}
          className="otp-field"
          onChange={handleChange}
          type="text"
          dataorder="0"
          value={props.value[0]}
          inputMode='numeric'
        />
        <input
          onKeyDown={keyPressCB}
          maxLength={1}
          onFocus={handleFocus}
          className="otp-field"
          onChange={handleChange}
          type="text"
          dataorder="1"
          inputMode='numeric'
          value={props.value[1]}
        />
        <input
          onKeyDown={keyPressCB}
          maxLength={1}
          onFocus={handleFocus}
          className="otp-field"
          onChange={handleChange}
          type="text"
          dataorder="2"
          value={props.value[2]}
          inputMode='numeric'
        />
        <input
          onKeyDown={keyPressCB}
          maxLength={1}
          onFocus={handleFocus}
          className="otp-field"
          onChange={handleChange}
          type="text"
          dataorder="3"
          value={props.value[3]}
          inputMode='numeric'
        />
        <input
          onKeyDown={keyPressCB}
          maxLength={1}
          onFocus={handleFocus}
          className="otp-field"
          onChange={handleChange}
          type="text"
          dataorder="4"
          value={props.value[4]}
          inputMode='numeric'
        />
        <input
          onKeyDown={keyPressCB}
          maxLength={1}
          onFocus={handleFocus}
          className="otp-field"
          onChange={handleChange}
          type="text"
          dataorder="5"
          value={props.value[5]}
          inputMode='numeric'
        />
      </div>
    </div>
  );
};

export default OTPField;
